<template>
        <v-row v-if="players.length>0">
            <v-col xs="12" sm="12" class="text-center">
                <img :src="event.imgurl" :height="130" />
            </v-col>
            <v-col xs="12" sm="12" class="headline font-weight-light mb-2 text-center">
                {{activesku.attributes.name}}
            </v-col>
            <v-col xs="12" sm="6"  v-for="(p,i) in event.teamsize" :key="i">
                Select player
                <v-btn outlined block @click="athlete=players[i], index=i, playerdialog=true" :class="(index===i)?'info white--text':''">
                    {{players[i].firstname || 'Player '}}<span class="ml-2">{{players[i].lastname || i+1}}</span>
                </v-btn>
            </v-col>
            <v-col xs="12">
                <BaseBtn v-if="players[1].partkey" @click="commitPlayers()">Next</BaseBtn>
            </v-col>

            <v-dialog v-model="playerdialog" max-width="400">
                <v-card>
                    <v-card-title>
                        <span v-if="!newathlete">
                            Add
                        </span>
                        <span v-else>
                            New
                        </span>
                        Player
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                                v-if="!newathlete"
                                @input="searchProfiles()"
                                outlined
                                :label="`Player ${index+1}`"
                                v-model="search"
                        ></v-text-field>
                        <v-list v-if="searchedplayers">
                            <v-list-item v-for="p in searchedplayers" :key="p.partkey" @click="selectPlayer(p)">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{p.firstname}} {{p.lastname}}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item @click="newathlete=true,searchedplayers=false,readonly=false,newPlayer()">
                                <v-list-item-content >
                                    <v-list-item-title class="green--text">
                                        Create New Player
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon class="green--text"><v-icon>{{$store.state.icons.plus}}</v-icon></v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        <v-layout wrap v-if="newathlete">
                            <v-flex xs12>
                                <v-text-field
                                        :readonly="readonly"
                                        outlined
                                        label="First Name"
                                        v-model="athlete.firstname"
                                ></v-text-field>
                                <v-text-field
                                        :readonly="readonly"
                                        outlined
                                        label="Last Name"
                                        v-model="athlete.lastname"
                                ></v-text-field>
                                <v-text-field
                                        :readonly="readonly"
                                        outlined
                                        label="Email - not required"
                                        :rules="[$store.state.rules.emailRules]"
                                        v-model="athlete.email"
                                ></v-text-field>
                                <v-text-field
                                        :readonly="readonly"
                                        outlined
                                        label="Cell - not required"
                                        :rules="[$store.state.rules.cellRules]"
                                        v-model="athlete.cell"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                    </v-card-text>
                    <v-card-actions>
                        <BaseBtn @click="playerdialog=false, searchedplayers=false, index=-1,newathlete=false,addPlayer(),search=''">Cancel</BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn :disabled="!(athlete.cell||athlete.email) && !(athlete.firstname&&athlete.lastname)" @click="savePlayer()">Done</BaseBtn>
                        <v-spacer></v-spacer>
                        <BaseBtn :disabled="!newathlete" @click="newathlete=false">Clear</BaseBtn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
    import BaseBtn from "../BaseBtn";
    const PLAYER = {
      firstname:'',
      lastname:'',
      email:'',
      phone:'',
      shirtsize:'',
      readonly:false
    }
  export default {
    components: {BaseBtn},
    name: "TourneyRegistration",
    data() {
      return {
        players:[],
        athlete:false,
        index:[0],
        search:'',
        playerdialog:false,
        searchedplayers:false,
        newathlete:false,
        readonly:false
      }
    },
    computed:{
      ...mapState(['activeevent','orders','activesku']),
      event(){
        return this.activeevent.event
      },
      skus(){
        return this.activeevent.skus
      },
      product(){
        return this.activeevent.product
      }
    },
    watch:{
      playerdialog(n,o){
        if(n && this.players[this.index].partkey){
          this.newathlete=true
          this.readonly=true
        } else {
          this.eadonly=false
        }
      }
    },
    mounted() {
      this.addPlayer()
    },
    methods: {
      ...mapActions(['post']),
      addPlayer(){
        for(let i =0; i < this.event.teamsize; i++){
          let p = Object.assign({}, PLAYER)
          p.unq = new Date().getTime()
          this.players.push(p)
        }
      },
      newPlayer(){
        this.athlete = Object.assign({},PLAYER)
      },
      async searchProfiles(k){
        let data = {
          search:this.search
        }
        let p = await this.$store.dispatch('post',{body:data,path:'api/register/searchprofiles'})
        console.log(p)
        this.searchedplayers = p
      },
      selectPlayer(p){
        console.log('ATHLETE:', p)
        let check = this.players.filter(f=>{return f.partkey===p.partkey})
        if(check.length>0)return
        this.players[this.index] = p
        this.searchedplayers=false;
        this.search=''
        this.playerdialog=false
        this.index=-1
      },
      async savePlayer(){
        console.log('ATHLETE:', this.athlete)
        if(!this.athlete.partkey){
          this.athlete.sport = 'beach'
          let p = await this.post({body:this.athlete,path:'api/register/newathlete'})
          if(p.error) return;
          this.athlete = p
          console.log(p)
        }
        this.playerdialog=false
        this.search=''
        this.players[this.index]=this.athlete
        this.index=-1;
        this.newathlete=false
      },
      commitPlayers(){
        this.$store.commit('setRegistrants',this.players)
        this.$store.commit('setRegistrationStep',2)
      }
    }
  }
</script>

<style scoped>

</style>